export default __webpack_public_path__ + "static/media/aboutus.46aeed00.jpg";